import React from "react";
import { Search } from "lucide-react";
import { cn } from "../../libs/utils";
import { Input } from "./input";

const SearchInput = ({ value, onChange, placeholder = "Search...", className }) => {
  return (
    <div className={cn("relative w-full sm:max-w-xs", className)}>
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9"
      />
    </div>
  );
};

export default SearchInput;
